// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__6WDO7","content":"styles_content__2sqTX","selectAll":"styles_selectAll__1mOki"};